import type { PageFields } from '@tribeplatform/gql-client/graphql'
import { isNotFound } from '@tribeplatform/gql-client/lib'
import type { Page, QueryHomepageArgs } from '@tribeplatform/gql-client/types'

import { useQuery, UseQueryOptions } from '../../lib/react-query/useQuery.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getHomepageKey, getSpaceKey } from '../../utils/keys/space.key.js'

export const useHomepage = (options: {
  variables: QueryHomepageArgs
  fields?: PageFields
  useQueryOptions?: UseQueryOptions<Page>
}) => {
  const { fields = 'default', useQueryOptions, variables } = options
  const { client } = useTribeClient()
  const pageKey = getHomepageKey({
    variables: { type: variables.type },
    fields,
  })

  const queryClient = useQueryClient()

  return useQuery<Page>(
    pageKey,
    () => client.spaces.getHomepage(variables, fields),
    {
      onError(err) {
        if (isNotFound(err)) {
          const spaceKey = getSpaceKey({
            fields: 'default',
            variables: { id: variables.type },
          })
          queryClient.setQueryData(spaceKey, null)
        }
      },
      onSuccess(data) {
        if (data?.space?.id) {
          const spaceKey = getSpaceKey({
            fields: 'default',
            variables: { id: data?.space?.id },
          })
          queryClient.setQueryData(spaceKey, data?.space)
        }
      },
      ...useQueryOptions,
    },
  )
}
